import {isSmartAdServerStageEnv} from "../../app/read_rp_environment_variables";

export const SmartAdSASTypes = {
    MONO_NATIVE_ADD: isSmartAdServerStageEnv ? 105162 : 96832,
    OFFER_OF_THE_MONTH: isSmartAdServerStageEnv ? 105161 : 98096,
    IMAGE: isSmartAdServerStageEnv ? 105211 : 105176,
    SURPRISE: isSmartAdServerStageEnv ? 107574 : 107573,
    HERO: isSmartAdServerStageEnv ? 121182 : 121177,
    TDA: isSmartAdServerStageEnv ? 133997 : 133996
};
import {isSmartAdServerStageEnv} from "../../app/read_rp_environment_variables";

export const SmartAdSASTypes = {
    MONO_NATIVE_ADD: isSmartAdServerStageEnv ? 105162 : 96832,
    OFFER_OF_THE_MONTH: isSmartAdServerStageEnv ? 105161 : 98096,
    IMAGE: isSmartAdServerStageEnv ? 105211 : 105176,
    SURPRISE: isSmartAdServerStageEnv ? 107574 : 107573,
    HERO: isSmartAdServerStageEnv ? 121182 : 121177,
    TDA: isSmartAdServerStageEnv ? 133997 : 133996
};
